import React from 'react';

interface Props<T> {
  readonly data: T;

  onClick?(data: T): void;
}

export function Clickable<T>(props: React.PropsWithChildren<Props<T>>): React.ReactElement {
  const { data, children, onClick } = props;

  const forwardClickHandler = React.useCallback((): void => {
    onClick?.(data);
  }, [data, onClick]);

  if (!React.isValidElement<React.HTMLAttributes<never>>(children)) {
    throw new Error('Clickable must have a single child');
  }

  return React.cloneElement(children, { onClick: forwardClickHandler });
}
